var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.16 49.16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Layer 2",
    d: "M42.44 49.16H6.72A6.73 6.73 0 010 42.44V6.72A6.72 6.72 0 016.72 0h35.72a6.73 6.73 0 016.72 6.72v35.72a6.73 6.73 0 01-6.72 6.72zM6.72 5.64a1.08 1.08 0 00-1.08 1.08v35.72a1.07 1.07 0 001.08 1.07h35.72a1.07 1.07 0 001.07-1.07V6.72a1.07 1.07 0 00-1.07-1.08H6.72zm16.72 29l16.35-16.41-4-4-15.31 15.33-7.14-7.14-4 4 8.17 8.18a4.18 4.18 0 005.93-.01z",
    fill: "#999"
  })))));
}
export default SvgOptedIn;